import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { ProductsSection } from 'src/components/products-section';
import type { PrismicSliceProductList, Product } from 'src/types';
import { plainText } from '../rich-text';
import {
  trackInternalNavigationClick,
  InternalNavigationScope,
} from 'src/globals/tracking/tracking';

const ProductList = ({
  title,
  products,
  listType,
}: PrismicSliceProductList) => {
  const { t, linkTo } = useAppContext();
  const showCompareLink = listType === 'Compare';
  const compareTitle = showCompareLink
    ? t('product', 'product-compare.compare')
    : undefined;
  const compareUrl = showCompareLink
    ? linkTo('productCompare', {
        products,
      })
    : undefined;
  return (
    <ProductsSection
      products={
        Array.isArray(products)
          ? products.filter((obj): obj is Product => Boolean(obj))
          : []
      }
      title={plainText(title)}
      linkTitle={compareTitle}
      linkPath={compareUrl}
      showLinkAsButton
      showCreateAlertButton={listType === 'Alert'}
      onProductCardClick={(data: { index: number; link: string }) =>
        trackInternalNavigationClick({
          scope: InternalNavigationScope.ARTICLE_PRODUCT_CARD,
          nextPage: data.link,
          index: data.index,
        })
      }
    />
  );
};

export default ProductList;
